var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-bitcoin"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bitcoin",
    clipPath: "url(#clip-bitcoin)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51",
    transform: "translate(-2.654 -2.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(2.654 2.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 30,
    height: 30,
    rx: 7,
    fill: "#ff5023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,7A7,7,0,0,1,7,0h6.514a16.364,16.364,0,0,1,.815,5.117A16.379,16.379,0,0,1,0,21.367Z",
    transform: "translate(0 0)",
    fill: "#ff6243"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M30.941,22.105a3.473,3.473,0,0,0-1.628-2.121l-.865-.5.5-.865a1,1,0,1,0-1.729-1l-.5.865-1.3-.749.5-.865a1,1,0,1,0-1.729-1l-.5.865-1.681-.97a1.036,1.036,0,0,0-1.365.263,1.005,1.005,0,0,0,.318,1.439l.865.5-3.993,6.916-.816-.471a1.036,1.036,0,0,0-1.365.263,1,1,0,0,0,.318,1.438l1.729,1-.5.865a1,1,0,1,0,1.729,1l.5-.865,1.3.749-.5.865a1,1,0,1,0,1.729,1l.5-.865.74.427a3.6,3.6,0,0,0,4.953-1.306,3.472,3.472,0,0,0,.294-2.553.135.135,0,0,0-.013-.036,3.489,3.489,0,0,0,2.509-4.286Zm-4.574,5.976a1.5,1.5,0,0,1-2.046.549l-4.755-2.745,1.5-2.6,4.755,2.745A1.5,1.5,0,0,1,26.367,28.081Zm2.5-4.323a1.5,1.5,0,0,1-2.046.549l-4.755-2.745,1.5-2.6,4.755,2.745a1.5,1.5,0,0,1,.549,2.046Z",
    transform: "translate(-6.229 -6.178)",
    fill: "#f1f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.1c59e9280443d9ded5d3e7d71dddc019.svg";
export { ForwardRef as ReactComponent };